import controller from './__init/controller';
import detectTabNav from './__frontend/detectTabNav';
import throttle from 'lodash/throttle';

let handled = false;

controller.init();

window.addEventListener('load', controller.loaded);
window.addEventListener('scroll', throttle(controller.scrolled, 100), {
	passive: true,
});
window.addEventListener('resize', throttle(controller.resized, 100));
window.addEventListener('keydown', (e) => {
	detectTabNav(e);
	controller.keyDown(e);
});

const handleMouseAndTouchEvents = (e) => {
	if (e.type === 'touchend') {
		handled = true;
		controller.mouseUp(e);
	} else if (e.type === 'mouseup' && !handled) {
		controller.mouseUp(e);
	} else {
		handled = false;
	}
};

document.addEventListener('mouseup', handleMouseAndTouchEvents);
document.addEventListener('touchend', handleMouseAndTouchEvents);

// Wrap ® symbols in <sup> tags
const wrapRegisteredSymbols = () => {
	const walker = document.createTreeWalker(
		document.body,
		NodeFilter.SHOW_TEXT,
		null,
		false
	);

	const textNodes = [];
	let node;
	while ((node = walker.nextNode())) {
		if (node.nodeValue.includes('®')) {
			textNodes.push(node);
		}
	}

	textNodes.forEach((textNode) => {
		// Skip if already inside a <sup> tag
		if (textNode.parentNode.nodeName.toLowerCase() === 'sup') {
			return;
		}

		const text = textNode.nodeValue;
		const parts = text.split('®');

		if (parts.length > 1) {
			const fragment = document.createDocumentFragment();

			parts.forEach((part, index) => {
				fragment.appendChild(document.createTextNode(part));

				if (index < parts.length - 1) {
					const sup = document.createElement('sup');
					sup.textContent = '®';
					fragment.appendChild(sup);
				}
			});

			textNode.parentNode.replaceChild(fragment, textNode);
		}
	});
};

document.addEventListener('DOMContentLoaded', wrapRegisteredSymbols);
